(function () {
  'use strict';

  const STORAGE_KEY = 'gr_personal_frameworks_v1';
  const PLAYBOOK_KEY = 'gr_toolbox_v1'; // ✅ use the same list as My Playbook


  function uid() { return 'pf_' + Math.random().toString(16).slice(2) + '_' + Date.now().toString(16); }
  function nowTs() { return Date.now(); }
  function safeJsonParse(str, fallback) { try { return JSON.parse(str); } catch { return fallback; } }
  function normalizeText(s) { return (s || '').toString().toLowerCase().trim(); }
  function clamp(str, max) { const s = (str || '').toString(); return s.length > max ? s.slice(0, max) : s; }
  function escapeHtml(str) {
    return (str || '').toString()
      .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;').replaceAll("'", '&#039;');
  }

  function formatBlueprintText(raw) {
  if (!raw) return '';

  // 1. Escape everything first (security!)
  let text = escapeHtml(raw);

  // 2. Bold: *text*
  text = text.replace(/\*(.*?)\*/g, '<strong>$1</strong>');

  // 3. Arrows: -> or =>
  text = text.replace(/-&gt;|=&gt;/g, '→');

  // 4. Split into lines and handle bullets
  const lines = text.split('\n');
  const htmlLines = lines.map(line => {
    if (line.startsWith('- ')) {
      return `<li>${line.slice(2)}</li>`;
    }
    return `<p>${line}</p>`;
  });

  // 5. Wrap bullets correctly
  let result = '';
  let inList = false;

  htmlLines.forEach(line => {
    if (line.startsWith('<li>')) {
      if (!inList) {
        inList = true;
        result += '<ul>';
      }
      result += line;
    } else {
      if (inList) {
        result += '</ul>';
        inList = false;
      }
      result += line;
    }
  });

  if (inList) result += '</ul>';

  return result;
}


  function loadState() {
    const base = {
      frameworks: [],
      categories: ['Mindset', 'Productivity', 'Communication', 'Leadership', 'Team', 'Business', 'Body'],
      version: 1
    };
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return base;
    const parsed = safeJsonParse(raw, base);
    parsed.frameworks = Array.isArray(parsed.frameworks) ? parsed.frameworks : [];
    parsed.categories = Array.isArray(parsed.categories) ? parsed.categories : base.categories;
    parsed.categories = [...new Set(parsed.categories.map(c => (c || '').toString().trim()).filter(Boolean))];
    return parsed;
  }
  function saveState(state) { localStorage.setItem(STORAGE_KEY, JSON.stringify(state)); }

  // ===== PF SHARE/IMPORT CONFIG =====
  const PF_API_BASE = 'https://mbti-proxy-op9i.vercel.app'; 
  // If you already have a proxy domain (mbti-proxy) use that base instead.

  async function tryImportFromUrl() {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('import');
    if (!token) return;

    try {
      const r = await fetch(`${PF_API_BASE}/api/pf/share?token=${encodeURIComponent(token)}`);
      const data = await r.json();
      if (!r.ok) throw new Error(data?.error || 'Import link invalid/expired.');

      const payload = data.payload;

      // Load current state
      let current = loadState();
      current.frameworks = Array.isArray(current.frameworks) ? current.frameworks : [];
      current.categories = Array.isArray(current.categories) ? current.categories : [];

      const upsert = (fw) => {
        const idx = current.frameworks.findIndex(x => x.id === fw.id);
        if (idx === -1) current.frameworks.unshift(fw);
        else current.frameworks[idx] = { ...current.frameworks[idx], ...fw, updatedAt: Date.now() };
      };

      if (payload?.type === 'pf_export_v1' && Array.isArray(payload.frameworks)) {
        payload.frameworks.forEach(upsert);
        if (Array.isArray(payload.categories)) {
          current.categories = Array.from(new Set([...current.categories, ...payload.categories].filter(Boolean)));
        }
      } else if (payload?.id && payload?.blueprint) {
        upsert(payload);
      } else {
        throw new Error('Import payload format not recognized.');
      }

      saveState(current);

      alert('Imported ✅ Your framework is now in Personal Frameworks.');

      // Clean URL: remove ?import=...
      params.delete('import');
      const clean = window.location.pathname +
        (params.toString() ? '?' + params.toString() : '') +
        window.location.hash;
      window.history.replaceState({}, '', clean);

      // Refresh UI
      state = loadState();
      render();

    } catch (e) {
      alert(e.message || 'Import failed.');
    }
  }



function loadPlaybookItems() {
  const raw = localStorage.getItem(PLAYBOOK_KEY);
  const items = raw ? safeJsonParse(raw, []) : [];
  return Array.isArray(items) ? items : [];
}
function savePlaybookItems(items) {
  localStorage.setItem(PLAYBOOK_KEY, JSON.stringify(items));
}

  function ensureCategory(state, cat) {
    const c = (cat || '').toString().trim();
    if (!c) return;
    if (!state.categories.includes(c)) {
      state.categories.push(c);
      state.categories = [...new Set(state.categories)];
      saveState(state);
    }
  }

 
  const mount = document.getElementById('gr-personal-frameworks-app');
  if (!mount) return;

  let state = loadState();
  syncFrameworkPlaybookFlags();
  let ui = { q: '', category: 'All', sort: 'updated_desc' };

  // Inline editor state
  let editorOpen = false;
  let editingId = null;
  // View mode state
    let viewerOpen = false;
    let viewingId = null;

  function initials(name) {
    const s = (name || '').toString().trim();
    if (!s) return 'GR';
    const parts = s.split(/\s+/).slice(0, 2);
    return (parts.map(p => p[0] || '').join('').toUpperCase()) || 'GR';
  }

  function scrollViewerToTop() {
  const el = document.getElementById('grpfViewer');
  if (!el) return;

  const headerOffset = 90; // 👈 adjust to your sticky header height
  const y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;

  window.scrollTo({ top: y, behavior: 'smooth' });
    }


  function getFiltered() {
    const q = normalizeText(ui.q);
    const cat = ui.category;

    let items = [...state.frameworks];

    if (cat !== 'All') items = items.filter(f => (f.category || '') === cat);

    if (q) {
      items = items.filter(f => {
        const hay = [
          f.name, f.memoryLine, f.focus, f.category,
          ...(Array.isArray(f.blueprint) ? f.blueprint.map(s => `${s.step || ''} ${s.question || ''}`) : [])
        ].join(' ');
        return normalizeText(hay).includes(q);
      });
    }

    items.sort((a, b) => {
      const au = a.updatedAt || 0, bu = b.updatedAt || 0;
      const an = normalizeText(a.name), bn = normalizeText(b.name);
      switch (ui.sort) {
        case 'name_asc': return an.localeCompare(bn);
        case 'name_desc': return bn.localeCompare(an);
        case 'created_desc': return (b.createdAt || 0) - (a.createdAt || 0);
        default: return bu - au;
      }
    });

    return items;
  }

function renderViewer() {
  if (!viewerOpen || !viewingId) return '';

  const fw = state.frameworks.find(x => x.id === viewingId);
  if (!fw) return '';

  const cat = fw.category ? `<span class="grpf-badge">${escapeHtml(fw.category)}</span>` : '';
  const pb = fw.inPlaybook ? `<span class="grpf-badge playbook">In My Playbook</span>` : '';

  const blueprintText = (fw.blueprint || [])
  .map(s => {
    if (s.question) return `${s.step} — ${s.question}`;
    return s.step;
  })
  .join('\n');
 
  return `
    <div class="grpf-view ${viewerOpen ? '' : 'hidden'}" id="grpfViewer">
      <div class="grpf-viewHead">
        <div>
          <div class="grpf-viewTitleRow">
            <div class="grpf-thumb grpf-thumb--small"><span>${escapeHtml(initials(fw.name))}</span></div>
            <h2 class="grpf-viewTitle">${escapeHtml(fw.name || 'Untitled')}</h2>
          </div>
          <div class="grpf-viewBadges">${cat} ${pb}</div>
        </div>

   
      </div>

      <div class="grpf-viewBody">
        <div class="grpf-viewLine">${escapeHtml(fw.memoryLine || '')}</div>

        ${fw.focus ? `
          <div class="grpf-viewBlock">
            <div class="grpf-viewLabel">Focus</div>
            <div class="grpf-viewText">${escapeHtml(fw.focus)}</div>
          </div>
        ` : ''}

      <div class="grpf-viewBlock">
        <div class="grpf-viewLabel">Blueprint</div>
        <div class="grpf-viewFormatted">
        ${formatBlueprintText(blueprintText)}
        </div> </div>
      </div>

           <div class="grpf-viewActions">
          <button class="grpf-btn secondary" id="grpfViewClose" type="button">Close</button>
          <button class="grpf-btn" id="grpfViewEdit" type="button">Edit</button>
        </div>
    </div>
  `;
}


  function renderEditor() {
    const catOptions = state.categories.map(c => `<option value="${escapeHtml(c)}">${escapeHtml(c)}</option>`).join('');
    return `
      <div class="grpf-editor ${editorOpen ? '' : 'hidden'}" id="grpfEditor">
        <div class="grpf-editorHead">
          <h2>${editingId ? 'Edit Framework' : 'Create Framework'}</h2>
          
        </div>

        <div class="grpf-editorGrid">
          <div class="grpf-field">
            <label>Framework name</label>
            <input class="grpf-input" id="grpfName" placeholder="e.g., WIN / BUILD / My Focus System" maxlength="60"/>
            <div class="grpf-help">Tip: 3–7 letters works great if you can (acronym), but not required.</div>
          </div>

          <div class="grpf-field">
            <label>Category</label>
            <div class="grpf-row">
              <select class="grpf-select" id="grpfCategoryPick" style="flex:1;">
                ${catOptions}
              </select>
              <button class="grpf-btn secondary" id="grpfNewCatInline" type="button">+ New</button>
            </div>
            <div class="grpf-help">Pick an existing category, or create a new one.</div>
          </div>

          <div class="grpf-field">
            <label>What are you trying to master right now?</label>
            <input class="grpf-input" id="grpfFocus" placeholder="e.g., Lead without micromanaging" maxlength="80"/>
            <div class="grpf-help">This makes it personal and keeps it focused.</div>
          </div>

        </div>

        <div class="grpf-divider"></div>

        <div class="grpf-field">
          <label>Memory line (one-liner)</label>
          <input class="grpf-input" id="grpfLine" placeholder="If you remember one sentence, it’s this…" maxlength="120"/>
          <div class="grpf-help">Aim for 4–7 words. Make it sound like something you’d tell yourself.</div>
        </div>

        <div class="grpf-field" style="margin-top:12px;">
          <label>Memory blueprint (steps)</label>
          <div class="grpf-help">
  <strong>Formatting tips:</strong> <code>*bold*</code> for emphasis. Use <code>-</code> for bullets. Use <code>-&gt;</code> for flow.<br>
</div>

          <textarea class="grpf-textarea" id="grpfBlueprint" placeholder="One step per line.
This is your memory blueprint — write it in a way you’ll remember and apply.

*How to think about steps:*
- Actions (what to do)
- Questions (what to ask yourself)
- A short story or logic sequence
- A trigger → response pattern

Examples:
When stressed => Pause and breathe
Then=> Reframe the situation
Finally => Act with intention
"></textarea><br>

        </div>

      
        <div class="grpf-editorActions">
         <button class="grpf-btn" id="grpfSave" type="button">Save</button>
            <button class="grpf-btn secondary" id="grpfCancelEdit" type="button">Cancel</button>
          </div>
            <div class="grpf-note" style="margin-top:10px;">
          Saved locally on this device (localStorage). Clearing browser data will remove it.
        </div>
      </div>
    `;
  }

  function syncFrameworkPlaybookFlags() {
  const items = loadPlaybookItems();
  const handles = new Set(items.map(i => i && i.handle).filter(Boolean));

  let changed = false;

  state.frameworks.forEach(fw => {
    const shouldBe = handles.has('pf:' + fw.id);
    if (!!fw.inPlaybook !== shouldBe) {
      fw.inPlaybook = shouldBe;
      changed = true;
    }
  });

  // Optional: persist the corrected flags so the UI stays consistent even offline
  if (changed) saveState(state);
}


  function renderCard(f) {
    const cat = f.category ? `<span class="grpf-badge">${escapeHtml(f.category)}</span>` : '';
    const pb = f.inPlaybook ? `<span class="grpf-badge playbook">In My Playbook</span>` : '';

    return `
      <div class="grpf-card" data-id="${escapeHtml(f.id)}">
        <div class="grpf-thumb">
            <span>${escapeHtml(initials(f.name))}</span>
        </div>

        <div class="grpf-cardMain">
          <p class="grpf-cardTitle">${escapeHtml(f.name || 'Untitled')}</p>
          <p class="grpf-cardLine">${escapeHtml(clamp(f.memoryLine || '', 90))}</p>

          <div class="grpf-cardBadges">
            ${cat} ${pb}
          </div>
        </div>

        <div class="grpf-cardBtns">
          <button class="grpf-mini" data-action="open">Open</button>
          <button class="grpf-mini secondary" data-action="togglePlaybook">${f.inPlaybook ? 'Remove Playbook' : '+ Add Playbook'}</button>
          <button class="grpf-mini" data-action="share">Share</button>
          <button class="grpf-mini danger" data-action="delete">Delete</button>
        </div>
      </div>
    `;
  }

  function renderEmpty() {
    return `
      <div class="grpf-empty">
        <div style="font-weight:900; color:#334155; margin-bottom:6px;">No frameworks found</div>
        <div style="margin-bottom:12px;">Create one that matches what you want to master right now.</div>
        <button class="grpf-btn" id="grpfCreateEmpty">+ Create Framework</button>
      </div>
    `;
  }

function openFromHashIfAny() {
  const hash = (window.location.hash || '').replace('#', '').trim();
  if (!hash) return;

  const fw = state.frameworks.find(x => x.id === hash);
  if (!fw) return;

  // open editor and load it
  openViewer(fw.id);

  // optional: highlight scroll to card (nice UX)
 // setTimeout(() => {
   // const card = document.querySelector(`.grpf-card[data-id="${CSS.escape(fw.id)}"]`);
    //if (card) card.scrollIntoView({ behavior: 'smooth', block: 'center' });
  //}, 150);
}

function scrollToPageTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}



    function preserveFocusRender(doRender) {
  const active = document.activeElement;
  const activeId = active && active.id ? active.id : null;

  // caret positions (only for inputs/textareas)
  const selStart = (active && typeof active.selectionStart === 'number') ? active.selectionStart : null;
  const selEnd   = (active && typeof active.selectionEnd === 'number') ? active.selectionEnd : null;

  doRender();

  if (!activeId) return;
  const el = document.getElementById(activeId);
  if (!el) return;

  el.focus({ preventScroll: true });

  if (selStart !== null && selEnd !== null && typeof el.setSelectionRange === 'function') {
    el.setSelectionRange(selStart, selEnd);
  }
}


  function render() {
    syncFrameworkPlaybookFlags();
    const filtered = getFiltered();
    const total = state.frameworks.length;
    const categories = ['All', ...state.categories];

    mount.innerHTML = `
      <div class="grpf-bar">
        <input class="grpf-input" id="grpfSearch" type="search" placeholder="Search your frameworks…" value="${escapeHtml(ui.q)}" />

        <select class="grpf-select" id="grpfCategory">
          ${categories.map(c => `<option value="${escapeHtml(c)}" ${c===ui.category?'selected':''}>${escapeHtml(c)}</option>`).join('')}
        </select>

        <div class="grpf-actions">
          <button class="grpf-btn secondary" id="grpfNewCategory">+ New Category</button>
          <button class="grpf-btn" id="grpfCreate">+ Create Framework</button>
        </div>
      </div>

      ${renderViewer()}
      ${renderEditor()}

      <div class="grpf-metaRow">
        <div class="grpf-pill"><strong>${filtered.length}</strong> shown / ${total} total</div>
        <div class="grpf-pill">
          <span>Sort</span>
          <select class="grpf-select" id="grpfSort" style="padding:7px 10px; border-radius:999px;">
            <option value="updated_desc" ${ui.sort==='updated_desc'?'selected':''}>Recently updated</option>
            <option value="created_desc" ${ui.sort==='created_desc'?'selected':''}>Recently created</option>
            <option value="name_asc" ${ui.sort==='name_asc'?'selected':''}>Name A–Z</option>
            <option value="name_desc" ${ui.sort==='name_desc'?'selected':''}>Name Z–A</option>
          </select>
        </div>
      </div>

      <div class="grpf-grid" id="grpfGrid">
        ${filtered.length ? filtered.map(renderCard).join('') : renderEmpty()}
      </div>
    `;

    wireEvents();
    if (editorOpen) prefillEditor(editingId);
  }

  function wireEvents() {
    const elSearch = document.getElementById('grpfSearch');
    const elCategory = document.getElementById('grpfCategory');
    const elSort = document.getElementById('grpfSort');

    elSearch.addEventListener('input', () => {
    ui.q = elSearch.value;
    preserveFocusRender(render);
    });

    elCategory.addEventListener('change', () => {
    ui.category = elCategory.value;
    preserveFocusRender(render);
    });

    elSort.addEventListener('change', () => {
    ui.sort = elSort.value;
    preserveFocusRender(render);
    });

    document.getElementById('grpfCreate').addEventListener('click', () => openEditor(null));
    document.getElementById('grpfNewCategory').addEventListener('click', promptNewCategory);

    const btnEmpty = document.getElementById('grpfCreateEmpty');
    if (btnEmpty) btnEmpty.addEventListener('click', () => openEditor(null));

    // Grid actions
    document.getElementById('grpfGrid').addEventListener('click', (e) => {
      const btn = e.target.closest('button[data-action]');
      if (!btn) return;

      const card = e.target.closest('.grpf-card');
      if (!card) return;

      const id = card.getAttribute('data-id');
      const action = btn.getAttribute('data-action');

      const fw = state.frameworks.find(x => x.id === id);
      if (!fw) return;

      if (action === 'open') openViewer(id);

      if (action === 'togglePlaybook') togglePlaybook(fw);

      if (action === 'share') {
        createShareLinkForFramework(fw)
          .then(async (link) => {
            try { await navigator.clipboard.writeText(link); } catch {}
            prompt('Share this link (copied if your browser allows):', link);
          })
          .catch(err => alert(err.message || 'Share failed.'));
      }

      if (action === 'delete') {
        const ok = confirm(`Delete "${fw.name || 'Untitled'}"? This cannot be undone.`);
        if (!ok) return;

        // 1) remove from playbook localStorage (gr_toolbox_v1)
        let items = loadPlaybookItems();
        const handle = 'pf:' + fw.id;
        items = items.filter(i => i && i.handle !== handle);
        savePlaybookItems(items);

        // 2) remove from personal frameworks localStorage (gr_personal_frameworks_v1)
        state.frameworks = state.frameworks.filter(x => x.id !== fw.id);
        saveState(state);

        // 3) if viewer is open on this fw, close it
        if (viewerOpen && viewingId === fw.id) {
          viewerOpen = false;
          viewingId = null;
        }

        render();
      }

    });

    // Viewer events (if open)
        const viewer = document.getElementById('grpfViewer');
        if (viewer && !viewer.classList.contains('hidden')) {
        const closeBtn = document.getElementById('grpfViewClose');
        const editBtn = document.getElementById('grpfViewEdit');

        if (closeBtn) closeBtn.addEventListener('click', closeViewer);
        if (editBtn) editBtn.addEventListener('click', () => {
            const id = viewingId;
            closeViewer();
            openEditor(id);
        });
        }

    // Editor events (if open)
    const editor = document.getElementById('grpfEditor');
    if (editor && !editor.classList.contains('hidden')) {
      document.getElementById('grpfCancelEdit').addEventListener('click', closeEditor);
      document.getElementById('grpfSave').addEventListener('click', saveFromEditor);

      document.getElementById('grpfNewCatInline').addEventListener('click', () => {
        const name = prompt('New category name:');
        if (!name) return;
        ensureCategory(state, name);
        saveState(state);
        render();
        openEditor(editingId);
        document.getElementById('grpfCategoryPick').value = name.trim();
      });

     
    }
  }

function openViewer(id) {
  viewerOpen = true;
  viewingId = id;
  editorOpen = false;
  editingId = null;
  render();

  setTimeout(scrollViewerToTop, 50);

}

function closeViewer() {
  viewerOpen = false;
  viewingId = null;
    render();
  scrollToPageTop();
}


  function openEditor(id) {
    editorOpen = true;
    editingId = id;
    render();

    // scroll editor into view (mobile-friendly)
    const ed = document.getElementById('grpfEditor');
    if (ed) ed.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function closeEditor() {
    editorOpen = false;
    editingId = null;
      render();
  scrollToPageTop();
  }

  function prefillEditor(id) {
    const fw = id ? state.frameworks.find(x => x.id === id) : null;

    const name = document.getElementById('grpfName');
    const cat = document.getElementById('grpfCategoryPick');
    const focus = document.getElementById('grpfFocus');
    const line = document.getElementById('grpfLine');
    const bp = document.getElementById('grpfBlueprint');

    if (!fw) {
      if (name) name.value = '';
      if (cat) cat.value = state.categories[0] || '';
      if (focus) focus.value = '';
      if (line) line.value = '';
      if (bp) bp.value = '';
      return;
    }

    name.value = fw.name || '';
    cat.value = fw.category || (state.categories[0] || '');
    focus.value = fw.focus || '';
    line.value = fw.memoryLine || '';
    bp.value = (fw.blueprint || []).map(s => {
      const step = (s.step || '').trim();
      const q = (s.question || '').trim();
      return q ? `${step} — ${q}` : step;
    }).join('\n');
  }

  function parseBlueprint(text) {
    const lines = (text || '').split('\n').map(l => l.trim()).filter(Boolean);
    const steps = lines.map(line => {
      let step = line, question = '';
      const m = line.split('—');
      if (m.length >= 2) { step = m[0].trim(); question = m.slice(1).join('—').trim(); }
      else {
        const m2 = line.split(' - ');
        if (m2.length >= 2) { step = m2[0].trim(); question = m2.slice(1).join(' - ').trim(); }
        else {
          const m3 = line.split(':');
          if (m3.length >= 2) { step = m3[0].trim(); question = m3.slice(1).join(':').trim(); }
        }
      }
      return { step: clamp(step, 28), question: clamp(question, 80) };
    });
    return steps.filter(s => (s.step || '').trim().length > 0);
  }

  function saveFromEditor() {
    const name = (document.getElementById('grpfName').value || '').trim();
    const category = (document.getElementById('grpfCategoryPick').value || '').trim();
    const focus = (document.getElementById('grpfFocus').value || '').trim();
    const memoryLine = (document.getElementById('grpfLine').value || '').trim();
    const blueprintRaw = (document.getElementById('grpfBlueprint').value || '').trim();

    if (!name) return alert('Please enter a framework name.');
    if (!memoryLine) return alert('Please enter a memory line (one-liner).');

    const blueprint = parseBlueprint(blueprintRaw);
    if (blueprint.length < 3) return alert('Please add at least 3 blueprint steps (one per line).');

    ensureCategory(state, category);

    const ts = nowTs();

    if (editingId) {
      const fw = state.frameworks.find(x => x.id === editingId);
      if (!fw) return;

      fw.name = clamp(name, 60);
      fw.category = category;
      fw.focus = clamp(focus, 80);
      fw.memoryLine = clamp(memoryLine, 120);
      fw.blueprint = blueprint;
      fw.updatedAt = ts;


      saveState(state);

      // if it is in playbook, update playbook entry text too
      if (fw.inPlaybook) syncPlaybookEntry(fw);

      closeEditor();
      return;
    }

    const fw = {
      id: uid(),
      name: clamp(name, 60),
      category,
      focus: clamp(focus, 80),
      memoryLine: clamp(memoryLine, 120),
      blueprint,
      inPlaybook: false,
      createdAt: ts,
      updatedAt: ts
    };

    state.frameworks.unshift(fw);
    saveState(state);
    closeEditor();
  }

  function promptNewCategory() {
    const name = prompt('New category name:');
    if (!name) return;
    ensureCategory(state, name);
    saveState(state);
    ui.category = name.trim();
    render();
  }

    async function createShareLinkForFramework(fw) {
    const ownerAnonId = (window.GR && (window.GR.anonId || window.GR.userId)) || null;

    const payload = {
      type: 'pf_export_v1',
      frameworks: [fw],
      categories: [fw.category].filter(Boolean),
      exportedAt: Date.now()
    };

    const r = await fetch(`${PF_API_BASE}/api/pf/share`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ payload, ownerAnonId, expiresInDays: 30 })
    });

    const data = await r.json();
    if (!r.ok) throw new Error(data?.error || 'Share failed');

    return `https://greatreminders.com/pages/personal-frameworks?import=${encodeURIComponent(data.token)}`;
  }


  // --- Playbook integration (localStorage) ---
 function togglePlaybook(fw) {
  let items = loadPlaybookItems();

  // ✅ unique handle per personal framework
  const handle = 'pf:' + fw.id;

  // toggle flag (for the Personal Frameworks UI badge/button text)
  fw.inPlaybook = !fw.inPlaybook;
  //fw.updatedAt = nowTs();

  const url = '/pages/personal-frameworks#' + fw.id;

  if (fw.inPlaybook) {
    // add/update in the SAME structure as other items
    items = items.filter(i => i.handle !== handle);

    items.unshift({
      handle,
      title: fw.name,
      url,                          // keep hash
      addedAt: Date.now(),
      lastUpdated: fw.updatedAt,
      status: 'not_started',
      appliedCount: 0,
      reviewCount: 0,
      notes: '',
      summary: fw.memoryLine || '', // ✅ shows in your My Playbook UI
      nextAction: '',
      // optional extras (won't break anything):
      source: 'personal',
      category: fw.category || '',
      focus: fw.focus || ''
    });
  } else {
    // remove
    items = items.filter(i => i.handle !== handle);
  }

  savePlaybookItems(items);
  saveState(state);
  render();
}



  function syncPlaybookEntry(fw) {
  const handle = 'pf:' + fw.id;
  const items = loadPlaybookItems();
  const idx = items.findIndex(i => i.handle === handle);
  if (idx >= 0) {
    items[idx] = {
      ...items[idx],
      title: fw.name,
      url: '/pages/personal-frameworks#' + fw.id,
      summary: fw.memoryLine || '',
      lastUpdated: fw.updatedAt
    };
    savePlaybookItems(items);
  }
}



  render();
  openFromHashIfAny();
  tryImportFromUrl();   // ✅ add this line

})();
